import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { GetGiftBoxParams, GiftItemType } from '@models/gift';
import { useFlow } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

function useGiftBox(giftBoxItemId: string, params: GetGiftBoxParams) {
    const { data, status } = useQuery(queries.giftBox.detail(giftBoxItemId, params));
    const { pop } = useFlow();
    const toast = useToast();
    useEffect(() => {
        if (status === 'error') {
            toast.error('선물함 아이템을 불러오는데 실패했습니다.');
            pop();
        }
    }, [status, pop, toast]);
    return data;
}

export default useGiftBox;
